import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { infoBlockLogic } from './info_block.logic';
import { InfoBlockReadView } from './InfoBlockViews';

export const infoBlockPlugin: ActivityPlugin<'info_block'> = {
  ...infoBlockLogic,
  displayName: GAME_MODE_CATALOG.info_block.displayName,
  icon: GAME_MODE_CATALOG.info_block.icon,
  HostView: InfoBlockReadView,
  StudentView: InfoBlockReadView,
  ProjectorView: InfoBlockReadView,
};

export { demoInfoBlockPayload } from './info_block.logic';
